query Lead($id: String) {
  lead(id: $id) {
    id
    firstname
    lastname
    email
  }
}
